module.exports = __webpack_public_path__ + "static/media/rectangle_selected.7cf02505.svg";